import { ReactNode } from 'react';
import { BottomNavigation } from '../shared/components';
import { ModuleDefinition } from '../shared/config/modules';
import { LccRole } from '../shared/auth/types';

/**
 * Shell principal de UNA aplicacion de la Suite: contenido + Bottom
 * Navigation fija. Se reserva padding-bottom para que el contenido nunca
 * quede oculto tras la barra.
 *
 * Recibe `getVisibleModules` para poder usarse tanto en Control Operativo
 * (default) como en Gestion Humana (ver shared/config/hrModules.ts) - cada
 * una con su propio catalogo de pantallas.
 */
export function AppShell({ children, getVisibleModules }: { children: ReactNode; getVisibleModules?: (role: LccRole, allowedModules: string[] | null) => ModuleDefinition[] }) {
  return (
    <div className="mx-auto flex min-h-screen max-w-3xl flex-col bg-surface-subtle">
      <main className="flex-1 pb-24">{children}</main>
      <BottomNavigation getVisibleModules={getVisibleModules} />
    </div>
  );
}
